import GamesRegistryPage from './components/GamesRegistry'

export default function BgmnApp() {
  return <GamesRegistryPage />
}
